import { PADDING_GAP } from '@/catalog-apps/components/config'
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/shadcn/carousel'
import { useRestClient } from '@/contexts/QueryProvider'
import Autoplay from 'embla-carousel-autoplay'
import { Link } from 'react-router'
import { AppCard } from './AppCard'

export function AppsCarousel() {
  const { getLandingApiGetApplicationExternal } = useRestClient()
  const { data: apps } = getLandingApiGetApplicationExternal.useSuspenseQuery(undefined)
  return (
    <Carousel
      plugins={[
        Autoplay({
          delay: 5000,
        }),
      ]}
      opts={{
        align: 'center',
        loop: true,
      }}
      // className="w-full max-w-4xl rounded-2xl bg-offwhite"
      style={{ width: `calc(100vw - ${PADDING_GAP * 2}px)` }}
      className="bg-offwhite relative rounded-2xl"
    >
      <CarouselContent className="-ml-4">
        {apps?.map((app) => (
          // <CarouselItem key={app_id} className="md:basis-1/2">
          <CarouselItem key={app.app_id} className="basis-2/5 pl-4">
            <Link className="group block h-full transition-all duration-300" to={`/featured-apps/${app.app_id}`}>
              <div className="p-10">
                <AppCard app={app} layout="carousel" />
              </div>
            </Link>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,hsl(var(--background)),transparent_30%,transparent_70%,hsl(var(--background)))]" />
    </Carousel>
  )
}
